import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { User } from "models/propTypes/userProfilePropTypes";
import { DateConstants } from "utils/constants";
import { WintSuperkollAPIModel as ApiModels, WintUtilsWebApi } from "wint-api-client/dist/types";
import { SalaryDraftFormTypes } from "models/formTypes";
import { TableEnums } from "models/enums";
import { Grid } from "@mui/material";
import { SalaryDraftsListProps } from "models/propTypes/salaryPropTypes";
//#endregion
//#region components
import { TableAsync, useFilterContext } from "components/common";
import SalaryDraftStatusTags from "./salaryStatusTags";
import { useSalaryService } from "serviceHooks";
//#endregion
import { DateHelper, LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const SalaryDraftListView: React.FC<SalaryDraftsListProps> = (props) => {
  const salaryService = useSalaryService();
  const { filter } = useFilterContext<SalaryDraftFormTypes.SalaryFilter>();

  const filterFunc = React.useCallback(
    (baseFilter: WintUtilsWebApi.Filter) => salaryService.filterSalaryDrafts(baseFilter, filter ?? {}),
    [filter]
  );

  const getItemUrl = (id: number | string) => UrlHelper.formatPath(`/Employees/Salaries/${id}`);

  return (
    <>
      <Grid container>
        <TableAsync<ApiModels.SalaryDraft>
          tableId={TableEnums.TableType.SalaryDraftList}
          properties={{
            ownerName: {
              description: TranslationKeys.Common.Receiver,
              formatter: (salary: ApiModels.SalaryDraft) => new User(salary.owner_Id, salary.ownerName),
              maxWidth: 150,
              noWrap: true,
            },
            yearAndMonth: {
              description: TranslationKeys.Common.Period,
              formatter: (salary: ApiModels.SalaryDraft) =>
                LocalizationHelperInstance.getFormattedDate(
                  DateHelper.getDateFromYearMonth(salary.yearAndMonth),
                  DateConstants.MonthYearShortConfig
                ),
              noWrap: true,
              maxWidth: 100,
            },
            state: {
              description: TranslationKeys.Common.Status,
              formatter: (salary: ApiModels.SalaryDraft) => <SalaryDraftStatusTags state={salary.state} />,
              noWrap: true,
              maxWidth: 100,
            },
          }}
          filter={filterFunc}
          itemUrl={getItemUrl}
          maxRowCount={10}
          pagination="advanced"
          orderByProperty="yearAndMonth"
          orderByDescending
          reloadKey={props.reloadKey}
        />
      </Grid>
    </>
  );
};

export default SalaryDraftListView;
